import React from "react";
import logo from "../assets/hdr_title.png";
import { NavLink as Link } from "react-router-dom";
import { FaBars } from "react-icons/fa";
import styled from "styled-components";

const Nav = styled.nav`
  background: #6b1515;
  height: 50px;
  width: 100vw;
  //display: flex;
  //flex: 1;
  //position: fixed;
  //justify-content: space-between;
  //padding: 0.2rem calc((100vw - 1000px) / 2);
  //z-index: 12;
  /* Third Nav */
  /* justify-content: flex-start; */
`;

const NavLink = styled(Link)`
  color: #FFFFFF;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  cursor: pointer;
  &.active {
    color: #000000;
  }
`;

const Bars = styled(FaBars)`
  display: none;
  color: #CCCCCC;
  @media screen and (max-width: 768px) {
    display: block;
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(-100%, 75%);
    font-size: 1.8rem;
    cursor: pointer;
  }
`;

const Navbar = () => {
  return (
      <Nav>
        <Bars />
        <NavLink to="/"><img src={logo} className="App-logo" alt="logo" /></NavLink>
      </Nav>
  );
};

export default Navbar;